export const styles = theme => ({
  // Sidebar (desktop right rail). The parent column is `position: sticky`
  // (see step-address / step-extra styles); this wrap caps its height so a
  // very tall summary scrolls internally instead of clipping at the edge.
  sidebarWrap: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    '@media (min-width: 960px)': {
      // Cap height so the summary scrolls internally instead of clipping
      // when it gets tall (lots of extras + tip + promo expanded).
      // 88px = sticky top offset, 24px = bottom breathing room.
      maxHeight: 'calc(100vh - 112px)',
      overflowY: 'auto'
    }
  },
  sidebarLabel: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#94a3b8',
    marginBottom: 10
  },
  sidebarCard: {
    background: '#ffffff',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,0.04), 0 4px 16px rgba(15,23,42,0.04)',
    padding: '24px',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif"
  },
  sidebarCardEmbedded: {
    background: 'transparent',
    padding: 0,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif"
  },
  serviceHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: 12,
    marginBottom: 4
  },
  serviceName: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 17,
    fontWeight: 600,
    color: '#0f172a',
    lineHeight: 1.3
  },
  servicePrice: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 17,
    fontWeight: 600,
    color: '#37b45a',
    whiteSpace: 'nowrap'
  },
  details: {
    marginTop: 20,
    paddingTop: 20,
    borderTop: '1px solid #eef0f3',
    display: 'flex',
    flexDirection: 'column',
    gap: 14
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  detailLabel: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: '#94a3b8'
  },
  detailValue: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 14,
    color: '#334155',
    lineHeight: 1.4
  },
  extras: {
    marginTop: 20,
    paddingTop: 20,
    borderTop: '1px solid #eef0f3',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  extraRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 13,
    color: '#475569'
  },
  discountRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 13,
    color: '#37b45a',
    fontWeight: 500
  },
  totalWrap: {
    marginTop: 20,
    paddingTop: 16,
    borderTop: '1.5px solid #eef0f3',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  totalLabel: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 14,
    fontWeight: 500,
    color: '#475569'
  },
  totalAmount: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 22,
    fontWeight: 700,
    color: '#0f172a'
  },

  // Mobile collapsed bar (uses MUI ExpansionPanel)
  brief: {
    boxShadow: 'none',
    borderTop: '1px solid #eef0f3',
    borderBottom: '1px solid #eef0f3',
    margin: 0,
    '&::before': { display: 'none' }
  },
  briefSummary: {
    minHeight: 56,
    padding: '0 20px',
    '& .MuiExpansionPanelSummary-content': {
      margin: '12px 0'
    }
  },
  briefDetails: {
    padding: '0 20px 20px',
    background: '#f8fafc'
  },
  mobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: 12
  },
  mobileHeaderName: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 14,
    fontWeight: 600,
    color: '#0f172a'
  },
  mobileHeaderPrice: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    color: '#37b45a'
  }
})
